//@flow
import React, { Component } from "react";

type Props = {
  secureProductDetailsUrl: string
};

class ButtonShopInMax extends Component<Props> {
  redirectToSecureUrl(secureProductDetailsUrl: string) {
    window.location.href = secureProductDetailsUrl;
  }

  render() {
    return (
      <button
        className="shop-in-max"
        onClick={() =>
          this.redirectToSecureUrl(this.props.secureProductDetailsUrl)
        }
      >
        Shop in maX
      </button>
    );
  }
}

export default ButtonShopInMax;
